<template>
  <div class="bonuses p-24-32">
    <div class="box">
      <div class="title-b">{{$t('text_11')}}</div>
      <div class="item">
        <span>{{$t('bonuses')}} </span> <span>{{ bonus }}</span>
      </div>
      <div class="item">
        <span>{{$t('status')}}</span> <span>{{ status }}</span>
      </div>
      <img src="@/assets/img/bonus.jpg" alt="" class="img" />
      <div class="text">
       {{$t('text_12')}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bonuses",
  data() {
    return {
      profile: "",
      bonus: "",
      status: ""
    };
  },
  created() {
    this.getBonuses();
  },
  methods: {
    getBonuses() {
      this.profile = JSON.parse(localStorage.getItem("user"));
      this.bonus = this.profile.bonus_1c;
      this.status = this.profile.bonus_category;
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/cabinet/bonuses.vue